import {
  Box,
  Button,
  chakra,
  Checkbox,
  Flex,
  IconButton,
  shouldForwardProp,
  Stack,
  Text
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import Cookies from 'js-cookie';
import { useEffect, useMemo, useState } from 'react';
import { IoClose } from 'react-icons/io5';
import { useSelector } from 'react-redux';

import { COMMON_WEB_PATH } from '../../constant';
import CommonModal from '../Common/CommonModal';
import QRCode from 'qrcode.react';
import CommonConfirmButton from '../Common/CommonConfirmButton';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const LineCustomerModal = () => {
  const isMemberInfo = useSelector((state) => state.isMemberInfo);

  const { register_type } = isMemberInfo || {};

  const [checked, setChecked] = useState(false);
  const [open, setOpen] = useState(false);

  const isLine = useMemo(() => {
    return register_type === 'Line';
  }, [register_type]);

  const handleChecked = (e) => {
    setChecked(e.target.checked);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const line_url = `https://line.me/R/ti/p/${process.env.REACT_APP_LINE_CUSTOMER}`;
  const handleDirectToLine = () => {
    if (checked) {
      Cookies.set('dont_show_line_modal', '1', { expires: 365 });
    }
    window.location.href = line_url;
  };

  useEffect(() => {
    if (isLine) {
      setOpen(true);
    }
  }, [isLine]);

  return open && Cookies.get('dont_show_line_modal') != 1 ? (
    <>
      <CommonModal onConfirm={handleClose} title=" ">
        {/* LINE背景 */}
        <Stack
          position="absolute"
          zIndex="2"
          top="-10%"
          left="50%"
          w={'200px'}
          transform="translateX(-50%)"
          alignItems={'center'}
          justifyContent={'center'}
        >
          <img
            src={`${COMMON_WEB_PATH}/911TW/modal_LINE_banner.png`}
            alt="line"
            style={{
              width: '100%',
              height: 'auto'
            }}
          />
        </Stack>

        {/* LINE文字 */}
        <Box
          display="flex"
          alignItems={'center'}
          justifyContent={'center'}
          position="relative"
          flexDirection="column"
          gap="10px"
          h="200px"
          mt="20px"
        >
          <Text
            color="white"
            fontSize="30px"
            textShadow={'#9c72b1 1px 0 11px'}
            fontWeight={'700'}
          >
            LINE官方帳號
          </Text>
          <Box p={2} bg="white" borderRadius={2}>
            <QRCode value={line_url} />
          </Box>
        </Box>

        <CommonConfirmButton
          onClick={handleDirectToLine}
          _hover={{ filter: 'brightness(1.1)' }}
        />
        <Stack
          position="relative"
          alignItems={'center'}
          justifyContent={'center'}
          h="40px"
        >
          <Checkbox
            colorScheme="purple"
            size="lg"
            onChange={handleChecked}
            zIndex={3}
            checked={checked}
            sx={{
              background:
                'linear-gradient(180deg, #fff 0%,#fdd26a 60%,  #b07f20 80%,  #b07f20 100%)',
              WebkitBackgroundClip: 'text',
              backgroundClip: 'text',
              color: 'transparent',
              textShadow: '0px 1px 3px rgba(255, 215, 0, 0.4)',
              fontSize: '20px',
              fontWeight: 700
            }}
          >
            不再顯示
          </Checkbox>
        </Stack>
      </CommonModal>
    </>
  ) : null;
};

export default LineCustomerModal;
